import Zepto from 'zepto-webpack'
import AbstractMonitor from '@/toolbar/inspector/Monitors/AbstractMonitor'
import Events from '@/configuration/Events'
import CustomFilters from '@/host/service/CustomFilters'

export default class MetaViewportUndefined extends AbstractMonitor {
  monitor() {
    const meta = Zepto('meta')
    const viewport = meta.reduce(
      (acc, x) => acc || x.name === 'viewport',
      false
    )
    if (!viewport) {
      const errorCode = 'CLIENT_705'
      const customFilters = new CustomFilters(this.$locator)
      const baseAddress = customFilters.replaceBaseAddress(errorCode)
      this.$store.dispatch('warning', {
        errorCode,
        metadata: { baseAddress, console: true }
      })
    }

    return Promise.resolve(true)
  }
}
